define('search',['controller', 'lib/select2.min', 'lib/select2_locale_de_informal'], function(controller) {
    controller.on('search', function() {
        $('.select').attr('multiple');
        $('.select').select2({
            width: '100%',
            placeholder: 'Nur in diesen Tags suchen ▾',
            language: 'de_informal'
        });

    });
});
